export const input = {
  selector: '.v-component--focus-input',
  reactive: true,

  run(el, data, root) {
    const input = el.querySelector('input.v-field__input');
    const field = el.querySelector('.v-field');

    if (!input || !field) return;

    // Helper to apply classes
    function updateState() {
      const hasValue = input.value.trim() !== '';
      const isFocused = document.activeElement === input;


      if(isFocused) {
        el.classList.add('v-input--focused');
      } else {
        el.classList.remove('v-input--focused');
      }

      if (isFocused || hasValue) {
        el.classList.add('v-input--dirty');
        field.classList.add('v-field--active', 'v-field--dirty');
      } else {
        el.classList.remove('v-input--dirty');
        field.classList.remove('v-field--active', 'v-field--dirty');
      }
    }

    // Initialize on load
    updateState();

    // Events
    input.addEventListener('focus', updateState);
    input.addEventListener('blur', updateState);
    input.addEventListener('input', updateState);

    // API for programmatic use (optional)
    el.focusInput = {
      refresh: updateState
    };
  }
};
